import React, { useState } from 'react';
import { FaCameraRetro, FaLightbulb, FaCrown, FaUsers } from 'react-icons/fa';
import './about.css';
import Popupbox from '../popupbox/Popupbox';

const stats = [
  { id: 1, number: '8+', label: 'Years of Excellence' },
  { id: 2, number: '1,200+', label: 'Shoots Completed' },
  { id: 3, number: '450+', label: 'Models & Artists' },
  { id: 4, number: '99%', label: 'Client Satisfaction' },
];

const values = [
  {
    id: 1,
    icon: <FaCrown />,
    title: 'High Fashion & Elegance',
    description: 'We curate bespoke visuals tailored to high-end couture, runway productions, and editorial storytelling.',
  },
  {
    id: 2,
    icon: <FaCameraRetro />,
    title: 'State-of-the-Art Production',
    description: 'Equipped with industry-standard cinema cameras, profoto lighting rigs, and specialized indoor acoustic sets.',
  },
  {
    id: 3,
    icon: <FaLightbulb />,
    title: 'Creative Direction',
    description: 'From moodboards and color palettes to framing and post-production grade, we handle end-to-end creative direction.',
  },
  {
    id: 4,
    icon: <FaUsers />,
    title: 'Talent Management',
    description: 'Direct collaboration with premier models, international casting agencies, stylists, and HMU professionals.',
  },
];

function AboutUs() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const handleOpenPopup = (e) => {
    e.preventDefault(); // Prevents page jump to #contact
    setIsPopupOpen(true);
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
  };
  return (
    <section className="about-page">
      {/* Hero Section */}
      <div className="about-hero">
        <span className="hero-subtitle">REDEFINING HIGH-FASHION VISUALS</span>
        <h1 className="hero-title">
          WELCOME TO <span>LUXURY STUDIOS</span>
        </h1>
        <p className="hero-description">
          Where cinematic lighting meets avant-garde editorial styling. We bring creative visions to life with world-class talent and uncompromising craftsmanship.
        </p>
      </div>

      {/* Main Story Split */}
      <div className="about-container">
        <div className="about-story-grid">
          <div className="story-image-wrap">
            <img
              src="https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=900&auto=format&fit=crop&q=80"
              alt="Luxury Studios Model Shoot"
              className="story-main-img"
            />
            <div className="story-badge">
              <span className="badge-num">100%</span>
              <span className="badge-text">Bespoke Production</span>
            </div>
          </div>

          <div className="story-content">
            <h3 className="section-label">OUR LEGACY</h3>
            <h2 className="section-heading">Crafting Timeless Portfolios & Campaigns</h2>
            <p className="story-para">
              Founded with the vision to elevate talent and creative agency production, <strong>Luxury Studios</strong> operates as a premier full-service photography, video production, and artist casting sanctuary.
            </p>
            <p className="story-para">
              Whether producing nationwide advertising campaigns, international model compcards, or cinematic lookbooks, our studio blends architectural elegance with advanced studio technology to ensure every frame reflects pure luxury.
            </p>

            <div className="story-actions">
              <a href="#portfolio" className="primary-btn">Explore Portfolio</a>
              <a href="#contact" className="secondary-btn"
              onClick={handleOpenPopup} >Book a Session</a>
            </div>
          </div>
        </div>

        {/* Stats Counter Bar */}
        {/* <div className="stats-bar">
          {stats.map((item) => (
            <div key={item.id} className="stat-card">
              <span className="stat-number">{item.number}</span>
              <span className="stat-label">{item.label}</span>
            </div>
          ))}
        </div> */}

        {/* Pillars / Values Section */}
        <div className="values-section">
          <div className="values-header">
            <h3 className="section-label">WHY LUXURY STUDIOS</h3>
            <h2 className="section-heading">Unmatched Standard Of Work</h2>
          </div>

          <div className="values-grid">
            {values.map((val) => (
              <div key={val.id} className="value-card">
                <div className="value-icon">{val.icon}</div>
                <h4 className="value-title">{val.title}</h4>
                <p className="value-desc">{val.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Popupbox 
        isOpen={isPopupOpen} 
        onClose={handleClosePopup} 
      />
    </section>
  );
}

export default AboutUs;